<template>
  <b-modal id="modal" hide-header scrollable v-model="modal">
    <b-img src="/imgs/credsec.png" fluid />    
    <template #modal-footer>
      <b-button variant="primary" size="sm" @click="modal = false"><i class="fas fa-thumbs-up"></i> OK</b-button>
    </template>
  </b-modal>
</template>
<script>

export default {
  data() {
    return {
      modal: false,
      distribuidor: null
    }
  },
  computed: {
    viewModal() {
      let view = true;
      // if (this.distribuidor.classe == 'A' ||
      //   this.distribuidor.classe == 'D' ||
      //   this.distribuidor.classe == 'L' ||
      //   this.distribuidor.classe == 'G'
      //   // (this.distribuidor.classe == 'P' &&
      //   //   (this.distribuidor.codigo == '0664829' ||
      //   //     this.distribuidor.codigo == '0599163' ||
      //   //     this.distribuidor.codigo == '0623786' ||
      //   //     this.distribuidor.codigo == '0643603' ||
      //   //     this.distribuidor.codigo == '0658068' ||
      //   //     this.distribuidor.codigo == '0655329' ||
      //   //     this.distribuidor.codigo == '0677028'
      //   //   )
      //   // )
      // ) {
      //   view = true
      // }
      return view
    }
  },

  methods: {
  },
  mounted() {
    if (document.getElementById('distribuidor').value) {
      this.distribuidor = JSON.parse(document.getElementById('distribuidor').value);
      if (this.viewModal) {
        this.modal = true
      }
    }
  },
}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/util/HomeComunicado.vue